import { AddressType } from '../enums/address-type.enum';

export abstract class ViewAddress {
  id: string;
  type: AddressType;
}
